import { render } from "./Mailings.vue?vue&type=template&id=788abd17&scoped=true&bindings={}"
import script from "./Mailings.vue?vue&type=script&lang=js"
export * from "./Mailings.vue?vue&type=script&lang=js"

import "./Mailings.vue?vue&type=style&index=0&id=788abd17&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-788abd17"

export default script